module.exports = new __parcel__URL__("failure.e27bb843.png").toString();